/***
 *  kylin 授权 接入方式1
 *  在应用初始化时候调用
 */
// kylin 授权
import { KylinOidcAuth } from '@xsyx/xs-kylin-auth';
// todo 实例化对象（注意正式环境和测试环境切换配置信息）

let platformKey = 'xsyx-xps-server'
let ssoBaseUrl = 'https://kylin.uat.xsyxsc.cn'; // sso地址
// window.$env = process.env.NODE_ENV

switch (process.env.NODE_ENV) {
  case 'development':
    ssoBaseUrl = 'https://kylin.uat.xsyxsc.cn';
    break;
  case 'production':
    platformKey = window.g_config.platformKey || 'xsyx-xps-server';
    ssoBaseUrl = window.g_config.ssoBaseUrl || 'https://kylin.xsyxsc.com';// 测试环境uat
    break;
  case 'gray':
    ssoBaseUrl = 'https://kylin.xsyxsc.com';
    break;
}


window.$kylinOidcAuth = new KylinOidcAuth({
  platformKey: platformKey, // 平台key
  ssoBaseUrl: ssoBaseUrl, // sso 授权服务地址
  saveCookie: true
});

window.$kylinOidcAuth.ready(function (token) {
  // this 指向的是 $kylinOidcAuth
  // console.log('====$kylinOidcAuth ready !====', token);
  // 获取权限（菜单、用户、按钮）
  Promise.all([this.oidcUserInfo()]).then(data => {
    console.log('===data===', data);
  }).catch(e => {
    console.log('error', e);
  })
})

function kyLinSSORun (cb = function () { console.log('空方法~'); }) {
  // 获取token,实际上已存储到 sessionstorage
  (async () => {
    await $kylinOidcAuth.readyPromise();
    // 自行存储 获取权限（菜单、用户、按钮
    cb();
  })();
}

export {
  kyLinSSORun,
  platformKey,
  ssoBaseUrl
}
